import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';

import { useFormService, FORM_STATES } from '@bingads-webui-react/form-core';

export const SaveBlocker = ({ children, loadingText }) => {
  const i18n = useContext(I18nContext);

  const { state } = useFormService();
  const isSaving = state.matches(FORM_STATES.SAVING);

  return (
    <UiBlocker blocking={isSaving} loadingText={loadingText || i18n.getString(_TL_('Saving...'))}>
      {children}
    </UiBlocker>
  );
};
SaveBlocker.propTypes = {
  children: PropTypes.node.isRequired,
  loadingText: PropTypes.string,
};
SaveBlocker.defaultProps = {
  loadingText: '',
};

export const LoadBlocker = ({ children, loadingText }) => {
  const i18n = useContext(I18nContext);

  const { state } = useFormService();
  const isLoading = state.matches(FORM_STATES.LOADING) || state.matches(FORM_STATES.FETCHING);

  return (
    <UiBlocker blocking={isLoading} loadingText={loadingText || i18n.getString(_TL_('Loading...'))}>
      {children}
    </UiBlocker>
  );
};
LoadBlocker.propTypes = {
  children: PropTypes.node.isRequired,
  loadingText: PropTypes.string,
};
LoadBlocker.defaultProps = {
  loadingText: '',
};

export const BusyBlocker = ({ children, loadingText }) => {
  const i18n = useContext(I18nContext);

  const { state } = useFormService();
  const isLoading = state.matches(FORM_STATES.LOADING) || state.matches(FORM_STATES.FETCHING);
  const isSaving = state.matches(FORM_STATES.SAVING);
  const defaultLoadingText = isLoading ? i18n.getString(_TL_('Loading...')) : i18n.getString(_TL_('Saving...'));

  return (
    <UiBlocker blocking={isLoading || isSaving} loadingText={loadingText || defaultLoadingText}>
      {children}
    </UiBlocker>
  );
};
BusyBlocker.propTypes = {
  children: PropTypes.node.isRequired,
  loadingText: PropTypes.string,
};
BusyBlocker.defaultProps = {
  loadingText: '',
};
